import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";

import { LoginContext } from "../../context/loginContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authenticatedUser } = useContext(LoginContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        authenticatedUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: rest.location && rest.location.pathname },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
